import styled from "styled-components";

export const Content = styled.div`
    width: 100%;
    height: 100%;
`;

export const ErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: var(--spacing-5);
    text-align: center;
`;

export const ErrorIcon = styled.div`
    margin-bottom: var(--spacing-3);
`;
